<template>
<div class="appdow">
    <div class="bg_box">
        <div class="rowBox">
            <h1 class="t_c t_c_xbt">写论文如此简单</h1>
            <p class="t_c f_c7 mt17" style="font-size: 18px;">你的论文好帮手，电脑没写完，手机接着写，论文实时同步，随时随地写论文</p>
            <div class="settop titlelist">
                <div class="textlist t_c_banner">
                    <img src="../../../static/images/appdow_banner.png" alt="">
                </div>
                <div class="t_c_r">
                    <div class="t_c_r_code">
                        <img :src="appDownImg" alt="">
                    </div>
                    <p>扫描下载笔杆论文APP</p>
                    <p>随时随地写论文，获取新思路</p>
                </div>
            </div>
            <div class="bi"></div>
            <div class="gan"></div>
        </div>
    </div>

    <div class="titlelist">
        <div class="imglist">
            <img src="../../../static/images/appdow_bk2_icon.png" alt="">
            <img class="bkwebbt" src="../../../static/images/appdow_bk2_web_bt.gif" alt="">
            <img class="bkwebnr" src="../../../static/images/appdow_bk2_web_nr.gif" alt="">
            <img class="bkappbt" src="../../../static/images/appdow_bk2_app_bt.gif" alt="">
            <img class="bkappnr" src="../../../static/images/appdow_bk2_app_nr.gif" alt="">
        </div>
        <div class="textlist textlistone">
            <h2>电脑没写完，手机接着写</h2>
            <p class="f_c7 f_sz ptop">pc端、手机端论文实时同步，等车、吃饭的时间都能写，随时随地都能写论文，确保不丢失。</p>
        </div>
    </div>
    <div class="titlelist titlelist2">
        <div class="textlist">
            <h2>随时随地获取新思路</h2>
            <p class="f_c7 f_sz ptop">不会写论文？没有思路？笔杆论文帮你解决，无论停在哪，笔杆论文都能帮你提供接下来的思路，不用再为不会写论文而担心了！</p>
        </div>
        <div class="Rimglist">
            <img src="../../../static/images/appdow_bk3_icon.png" alt="">
            <img class="RimglistDt2" src="../../../static/images/appdow_bk3_dt.gif" alt="">
        </div>
    </div>
    <div class="titlelist">
        <div class="imglist">
            <img src="../../../static/images/appdow_bk4_icon.png" alt="">
            <img class="RimglistDt3" src="../../../static/images/appdow_bk4_dt.gif" alt="">
        </div>
        <div class="textlist textlist3">
            <h2>一边写论文一边看资料</h2>
            <p class="f_c7 f_sz ptop">写论文、看资料，一个app帮你解决，可针对论文内容智能推荐高质量资料，也可按照关键词搜索论文资料，论文、资料一键切换，最方便的写论文工具！</p>
        </div>
    </div>
    <div class="code_box">
        <img class="codeimg" :src="appDownImg" alt="" srcset="" />
        <h2 class="dowtitle">扫描下载笔杆论文APP</h2>
        <p class="dow">随时随地写论文，获取新思路</p>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            appDownImg: ''
        }
    },
    methods: {
        // app下载二维码
        getAppDownImg() {
            let keyParams = {
                key: 'app_download_img_url'
            }
            this.oauthapi.appdownImg(keyParams).then(res => {
                this.appDownImg = res.data.setValue
            })
        }
    },
    created() {
        this.getAppDownImg()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
.appdow {
    .code_box {
        text-align: center;
        margin: 150px 0 85px;
        min-width: $mWidth;

        .codeimg {
            width: 116px;
            height: 116px;
        }

        .dow {
            font-size: 1.1rem;
            text-align: center;
            color: #333333;
        }

        .dowtitle {
            font-size: 1.5rem;
            font-weight: 400;
            margin: 10px 0;
        }
    }

    .bg_box {
        background: $boxcolor;
    }

    .rowBox {
        width: $mWidth;
        position: relative;
        margin: 0 auto;
        padding: 100px 0;

        .t_c_banner {
            position: relative;
            z-index: 2;
        }

        .t_c_xbt {
            font-size: 36px;
        }

        .Rimglist {
            width: 200px !important;
        }

        .t_c_r {
            position: relative;
            z-index: 2;
            margin-left: 30px;

            .t_c_r_code {
                background: #ccc;
                width: 150px;
                height: 150px;
                margin-top: 17rem;

                img {
                    display: block;
                    width: 100%;
                    height: 100%;
                }
            }

            p {
                &:nth-child(2) {
                    font-size: 18px;
                    margin: 10px 0;
                }
            }
        }

        .mt17 {
            margin-top: 1.1rem;
        }

        .bi {
            position: absolute;
            width: 534px;
            height: 546px;
            left: 0;
            bottom: 4rem;
            background: url('/static/images/b.png') no-repeat;
            background-size: 100%;
        }

        .settop {
            margin: 30px !important;
        }

        .gan {
            position: absolute;
            width: 534px;
            height: 546px;
            right: -50px;
            top: -60px;
            background: url('/static/images/g.png') no-repeat;
            background-size: 100%;
        }
    }

    .titlelist {
        width: $mWidth;
        display: flex;
        margin: 0 auto;
        justify-content: center;
        margin-top: 8rem;

        .imglist {
            margin-right: 5rem;
            width: 500px;
            position: relative;

            img {
                display: block;
                width: 100%;
            }

            .RimglistDt3 {
                position: absolute;
                top: 87px;
                left: 50px;
                width: 36%;
            }

            .bkwebbt {
                position: absolute;
                top: 132px;
                left: 150px;
                width: 20%;
            }

            .bkwebnr {
                position: absolute;
                top: 164px;
                left: 150px;
                width: 27%;
            }

            .bkappbt {
                position: absolute;
                top: 144px;
                right: 85px;
                width: 13%;
            }

            .bkappnr {
                position: absolute;
                top: 163px;
                right: 65px;
                width: 17%;
            }

        }

        .Rimglist {
            margin-left: 5rem;
            width: 500px;
            position: relative;

            img {
                display: block;
                width: 100%;
            }

        }

        .textlist {
            width: 500px;
            margin-top: 7rem;

            h2 {
                font-size: 32px;
                line-height: 35px;
            }

            .ptop {
                margin-top: 1.8rem;
                font-size: 16px;
                line-height: 25px;
            }
        }

        .textlistone {
            margin-top: 0;
            padding-top: 7rem;
            background: url(../../../static/images/appdow_bk2_icon2.png) no-repeat right top/30%;
        }

        .textlist3 {
            margin-top: 0;
            padding-top: 7rem;
            background: url(../../../static/images/appdow_bk2_icon2.png) no-repeat right top/30%;
        }
    }

    .titlelist2 {
        background: url(../../../static/images/appdow_bk3_icon2.png) no-repeat center center;
        background-size: 100%;

        .textlist {
            padding-top: 150px;
            padding-left: 5rem;
        }

        .Rimglist {
            margin-left: 237px;

            img {
                width: 100%;
            }

            .RimglistDt2 {
                position: absolute;
                top: 117px;
                left: 77px;
                width: 63%
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/appdow/appdow.vue